import React from "react";
import { IBannerData } from "../../exports/interfaces";

const FounderBanner = (props: { founderBannerData: IBannerData[] }) => {
  return (
    <section className="page-header" style={{ marginTop: "71px" }}>
      <div
        className="page-header-bg"
        style={{
          backgroundImage:
            props?.founderBannerData[0]?.image[0]?.media?.url &&
            `url(${process.env.REACT_APP_cmsUrl}/uploads/${props?.founderBannerData[0]?.image[0]?.media?.name})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
        }}
      ></div>
      <div className="container">
        <div className="page-header__inner">
          <h2>{props?.founderBannerData[0]?.title}</h2>
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span>/</span>
            </li>
            <li className="active">{props?.founderBannerData[0]?.title}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FounderBanner;
